module.exports = __webpack_public_path__ + "static/media/404.63959bd2.png";